import React from 'react'
import styled from 'styled-components'
import {Link} from 'react-router-dom'
import IconButton from '@mui/material/IconButton'
import {Create} from '@mui/icons-material'

const Item = styled(Link)`
    padding: 10px 20px;
    color: ${props => props.$current ? '#ffc300' : props.$mobile ? '#4a4a4a' : 'rgba(255, 255, 255, .7)'};
    width: 100%;
    font-weight: 700;
    font-size: 13px;
    cursor: pointer;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    :hover {
        background-color: ${props => props.$mobile ? 'initial' : 'rgba(0, 0, 0, .4)'};

        > span {
            filter:  ${props => props.$mobile ? '' : 'grayscale(0)'};
        }
    }

    > span {
        filter: ${props => props.$current ? 'grayscale(0)' : 'grayscale(100%)'};
        min-width: 40px;
    }

    > div {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`

const Button = styled(IconButton)`
	padding: 5px;
	margin-left: auto;
	color: #ffc300;
`

const Module = ({permissions, mobile, selected, name, icon, id, search, onDrag, onClick, resetFilter}) => {
    const onDragStart = (e) => {
        e.preventDefault()
        e.stopPropagation()

        onDrag(e, id)
    }

	const handleClick = (e) => {
		e.preventDefault()
		e.stopPropagation()
        
		onClick('edit')
	}

	return (
		<Item
			draggable={true}
			data-drag-module={id}
			data-module-id={selected ? null : id}
			to={`/module/${id}`}
			$current={search ? false : selected}
			$mobile={mobile}
			onClick={!mobile ? resetFilter : undefined}
			onDragStart={permissions ? onDragStart : undefined}
		>
			<span className={"entity-icon-medium entity-icon-" + icon} />
			<div>{name}</div>
			{!mobile && permissions && selected &&
				<Button onClick={handleClick}>
					<Create />
				</Button>
			}
		</Item>
	)
}

export default React.memo(Module)
